<template>
	<div class="date-range-filter">
		<div v-if="!showCustom" class="pill-group">
			<button
				v-for="preset in presets"
				:key="preset.key"
				type="button"
				class="pill-btn"
				:class="{ active: activePreset === preset.key }"
				@click="selectPreset(preset.key)"
			>
				{{ preset.label }}
			</button>
			<span class="pill-custom-link" @click="showCustom = true">Custom range ›</span>
		</div>

		<div v-else class="custom-range">
			<button
				type="button"
				class="back-icon-btn"
				title="Back to presets"
				@click="closeCustom"
			>
				<feather-icon icon="ChevronLeftIcon" size="16" />
			</button>
			<b-form-datepicker
				:value="fromDate"
				size="sm"
				right
				class="custom-range-input"
				placeholder="From date"
				local="en"
				:date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
				@input="onCustomFrom"
			/>
			<span class="sep">to</span>
			<b-form-datepicker
				:value="toDate"
				size="sm"
				right
				class="custom-range-input"
				placeholder="To date"
				local="en"
				:date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
				@input="onCustomTo"
			/>
		</div>
	</div>
</template>

<script>
import { BFormDatepicker } from "bootstrap-vue";
import moment from "moment";

export default {
	components: { BFormDatepicker },
	props: {
		fromDate: { type: String, default: null },
		toDate: { type: String, default: null },
		defaultPreset: { type: String, default: "month" },
	},
	data() {
		return {
			activePreset: this.defaultPreset,
			showCustom: false,
			presets: [
				{ key: "7d", label: "7D" },
				{ key: "month", label: "This Month" },
				{ key: "year", label: "This Year" },
			],
		};
	},
	created() {
		if (!this.fromDate || !this.toDate) {
			this.selectPreset(this.defaultPreset, { silent: true });
		}
	},
	methods: {
		rangeFor(key) {
			const now = moment();
			if (key === "7d") {
				return { from: now.clone().subtract(6, "days").format("YYYY-MM-DD"), to: now.format("YYYY-MM-DD") };
			}
			if (key === "year") {
				return { from: now.clone().startOf("year").format("YYYY-MM-DD"), to: now.clone().endOf("year").format("YYYY-MM-DD") };
			}
			return { from: now.clone().startOf("month").format("YYYY-MM-DD"), to: now.clone().endOf("month").format("YYYY-MM-DD") };
		},
		selectPreset(key, opts = {}) {
			this.activePreset = key;
			const { from, to } = this.rangeFor(key);
			this.$emit("update:from-date", from);
			this.$emit("update:to-date", to);
			if (!opts.silent) {
				this.$emit("change", { from, to });
			}
		},
		onCustomFrom(value) {
			this.activePreset = null;
			this.$emit("update:from-date", value);
			this.$emit("change", { from: value, to: this.toDate });
		},
		onCustomTo(value) {
			this.activePreset = null;
			this.$emit("update:to-date", value);
			this.$emit("change", { from: this.fromDate, to: value });
		},
		closeCustom() {
			this.showCustom = false;
			this.selectPreset(this.defaultPreset);
		},
	},
};
</script>

<style lang="scss" scoped>
.date-range-filter {
	display: flex;
	align-items: center;
}
.pill-group {
	display: flex;
	align-items: center;
	background: #fff;
	border: 1px solid #e8e6f3;
	border-radius: 999px;
	padding: 3px;
	gap: 2px;
}
.pill-btn {
	border: none;
	background: transparent;
	padding: 6px 14px;
	border-radius: 999px;
	font-size: 12.5px;
	font-weight: 600;
	color: #6b6685;
	cursor: pointer;
	transition: background 0.15s ease, color 0.15s ease;

	&:hover {
		background: rgba(115, 103, 240, 0.08);
	}

	&.active {
		background: #7367f0;
		color: #fff;
	}
}
.pill-custom-link {
	font-size: 12px;
	color: #7367f0;
	font-weight: 600;
	cursor: pointer;
	padding: 6px 10px;
	white-space: nowrap;
}
.custom-range {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: nowrap;
}
.back-icon-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	flex-shrink: 0;
	border: 1px solid #e8e6f3;
	border-radius: 8px;
	background: #fff;
	color: #7367f0;
	cursor: pointer;
	transition: background 0.15s ease;

	&:hover {
		background: rgba(115, 103, 240, 0.08);
	}
}
.custom-range .sep {
	color: #6b6685;
	font-size: 12.5px;
	flex-shrink: 0;
}
.custom-range ::v-deep .custom-range-input {
	width: 140px;
	flex-shrink: 0;
}
.custom-range ::v-deep .custom-range-input .form-control {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
